import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { GroupMatchExclusionsDrawerComponent } from '@main-client/src/app/group-match-exclusions-drawer/group-match-exclusions-drawer.component';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import { ProgramMembership } from '@libs/src/models/program-membership.model';
import { Program } from '@libs/src/models/program.model';

@Injectable()
export class GroupMatchExclusionsDrawerService {
  constructor(public drawerService: NzDrawerService) {}

  openDrawer(
    account: Account,
    group: Group,
    program?: Program,
    programMembership?: ProgramMembership,
  ) {
    return this.drawerService.create({
      nzBodyStyle: { padding: 0 },
      nzContent: GroupMatchExclusionsDrawerComponent,
      nzData: { account, group, program, programMembership },
      nzTitle: $localize`:@@groupMatchExclusionsDrawer.title: ${account.full_name}'s match exclusions`,
      nzWidth: '600px',
    });
  }
}
